var _defs, _path, _g, _path2, _g2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicPresentations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3faff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.62,45.29h-25.25c-5.9,0-10.7-4.8-10.7-10.7V7.05c0-.41.34-.75.75-.75h45.14c.41,0,.75.34.75.75v27.54c0,5.9-4.8,10.7-10.7,10.7ZM8.18,7.8v26.79c0,5.07,4.13,9.2,9.2,9.2h25.25c5.07,0,9.2-4.13,9.2-9.2V7.8H8.18Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.96,58.21c-.13,0-.26-.03-.38-.1l-6.96-4.03c-.23-.13-.37-.38-.37-.65v-8.89c0-.41.34-.75.75-.75s.75.34.75.75v8.46l6.58,3.81c.36.21.48.67.27,1.02-.14.24-.39.37-.65.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.04,58.21c-.26,0-.51-.13-.65-.37-.21-.36-.08-.82.27-1.02l6.58-3.81v-8.46c0-.41.34-.75.75-.75s.75.34.75.75v8.89c0,.27-.14.51-.37.65l-6.96,4.03c-.12.07-.25.1-.38.1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.65,7.8H4.35c-1.52,0-2.75-1.23-2.75-2.75v-.51c0-1.52,1.23-2.75,2.75-2.75h51.3c1.52,0,2.75,1.23,2.75,2.75v.51c0,1.52-1.23,2.75-2.75,2.75ZM4.35,3.29c-.69,0-1.25.56-1.25,1.25v.51c0,.69.56,1.25,1.25,1.25h51.3c.69,0,1.25-.56,1.25-1.25v-.51c0-.69-.56-1.25-1.25-1.25H4.35Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,27.65c-.15,0-.3-.05-.43-.14l-8.56-6.05c-.2-.14-.32-.37-.32-.61s.12-.47.32-.61l8.56-6.05c.26-.18.61-.18.87,0l8.56,6.05c.2.14.32.37.32.61s-.12.47-.32.61l-8.56,6.05c-.13.09-.28.14-.43.14Zm-7.26-6.8l7.26,5.13,7.26-5.13-7.26-5.13-7.26,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,37.55c-.15,0-.3-.05-.43-.14l-8.56-6.05c-.34-.24-.42-.71-.18-1.05.24-.34.71-.42,1.04-.18l8.12,5.74,8.12-5.74c.34-.24.8-.16,1.04.18.24.34.16.81-.18,1.05l-8.56,6.05c-.13.09-.28.14-.43.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.56,31.5c-.41,0-.75-.34-.75-.75v-9.9c0-.41.34-.75.75-.75s.75.34.75.75v9.9c0,.41-.34.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,37.55c-.41,0-.75-.34-.75-.75v-9.9c0-.41.34-.75.75-.75s.75.34.75.75v9.9c0,.41-.34.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.44,31.5c-.41,0-.75-.34-.75-.75v-9.9c0-.41.34-.75.75-.75s.75.34.75.75v9.9c0,.41-.34.75-.75.75Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48,38.74c-.41,0-.75-.34-.75-.75v-16.84c0-.41.34-.75.75-.75s.75.34.75.75v16.84c0,.41-.34.75-.75.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.74,24.21c-.41,0-.75-.34-.75-.75v-11.14c0-.41.34-.75.75-.75s.75.34.75.75v11.14c0,.41-.34.75-.75.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.26,34.38c-.41,0-.75-.34-.75-.75v-8.64c0-.41.34-.75.75-.75s.75.34.75.75v8.64c0,.41-.34.75-.75.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12,30.39c-.41,0-.75-.34-.75-.75V12.8c0-.41.34-.75.75-.75s.75.34.75.75v16.84c0,.41-.34.75-.75.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicPresentations);
export default __webpack_public_path__ + "static/media/Dynamic Presentations.2a0dbb5499a2af1067fabb1a2ec9a045.svg";
export { ForwardRef as ReactComponent };